<div class="atn-adjustment-tab">
  <atn-ds-section
    name="General"
    height="244"
  >
    <div class="atn-adjustment-tab__general-section">
      <atn-ds-select-single-ec
        label="Adjustment Label"
        descriptor="Slideout.AdjustmentLabel"
        [collection]="adjustmentLabelEc"
        [selectionTarget]="selectionTarget"
      />
    </div>
  </atn-ds-section>
  <atn-ds-section
    name="Mapping"
    height="calc(100% - 244px)"
  >
    <div class="atn-adjustment-tab__table">
      <!-- TODO: table will be replaced by 'embedded' table once Vuk finishes implementing it. -->
      <div class="atn-adjustment-tab__table-row">
        <div
          class="atn-adjustment-tab__table-header-cell atn-adjustment-tab__table-cell-code"
        >
          Code
        </div>
        <div
          class="atn-adjustment-tab__table-header-cell atn-adjustment-tab__table-cell-sub-code"
        >
          Sub Code
        </div>
        <div
          class="atn-adjustment-tab__table-header-cell atn-adjustment-tab__table-cell-exclusion"
        >
          Exclusion
        </div>
        <div
          class="atn-adjustment-tab__table-header-cell atn-adjustment-tab__table-cell-weight"
        >
          %&nbsp;<!--
          --><span
            class="atn-adjustment-tab__table-cell-weight-percents"
            [class.atn-adjustment-tab__table-cell-weight-percents--danger]="
              !areEntriesTotal100Sg()
            "
            >({{ entriesTotalPercentSg() }}/100)</span
          >
        </div>
        <div
          class="atn-adjustment-tab__table-header-cell atn-adjustment-tab__table-cell-actions"
        >
          <i
            (click)="addEntryHandler()"
            class="atn-icon atn-plus atn-blue"
          ></i>
        </div>
      </div>
      <div class="atn-adjustment-tab__table-body">
        @for (entry of entriesSg(); track idx; let idx = $index) {
          <div
            class="atn-adjustment-tab__table-row"
            (mouseenter)="rowHoveringIdx = idx"
            (mouseleave)="rowHoveringIdx = undefined"
          >
            <div
              class="atn-adjustment-tab__table-cell atn-adjustment-tab__table-cell-code"
            >
              <div class="atn-adjustment-tab__table-cell-control">
                <atn-ds-select-single-ec
                  [descriptor]="'Slideout.Entry' + idx + '.Category'"
                  [prepend]="getPrependedIdcCategoryItems(entry)"
                  [selectionTarget]="entrySelectionTargetLookupSg()[idx]"
                  [collection]="idcFunctionCategoryEc"
                  data-test-id="mapping-code"
                />
              </div>
            </div>
            <div
              class="atn-adjustment-tab__table-cell atn-adjustment-tab__table-cell-sub-code"
            >
              <div class="atn-adjustment-tab__table-cell-control">
                @let groupId = getIdcSubcategoryGroupId(entry);

                @if (groupId !== undefined) {
                  <atn-ds-select-single-ec
                    [descriptor]="'Slideout.Entry' + idx + '.Subcategory'"
                    [group]="groupId"
                    [selectionTarget]="entrySelectionTargetLookupSg()[idx]"
                    [collection]="idcFunctionSubcategoryEc"
                    [hideOnEmpty]="true"
                    data-test-id="mapping-sub-code"
                  />
                }
              </div>
            </div>
            <div
              class="atn-adjustment-tab__table-cell atn-adjustment-tab__table-cell-exclusion"
            >
              <div class="atn-adjustment-tab__table-cell-control">
                <atn-ds-select-single-ec
                  [descriptor]="'Slideout.Entry' + idx + '.Exclusion'"
                  [selectionTarget]="entrySelectionTargetLookupSg()[idx]"
                  [collection]="exclusionLabelEc"
                />
              </div>
            </div>
            <div
              class="atn-adjustment-tab__table-cell atn-adjustment-tab__table-cell-weight"
            >
              <div class="atn-adjustment-tab__table-cell-control">
                <atn-ds-number
                  [type]="IntrinsicValueType.Percent"
                  [config]="{ min: 1, max: 100 }"
                  [value]="entry.percent"
                  (change)="percentChangeHandler(idx, $event)"
                />
              </div>
            </div>
            <div
              class="atn-adjustment-tab__table-cell atn-adjustment-tab__table-cell-actions"
            >
              @if (rowHoveringIdx === idx && entriesSg().length > 0) {
                <i
                  class="atn-icon atn-trash atn-red"
                  (click)="removeEntryHandler(idx)"
                ></i>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </atn-ds-section>
</div>
